"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetSyncStateSchema = exports.UserAssetFlagSchema = exports.UpdateQuotaRequestSchema = exports.UserQuotaSchema = exports.RejectWithdrawalRequestSchema = exports.AdminWithdrawalListSchema = exports.AdminWithdrawalSchema = exports.AdminWithdrawalQuerySchema = void 0;
const zod_1 = require("zod");
const wallet_1 = require("../wallet");
const withdrawals_1 = require("../withdrawals");
const PERIOD = /^\d{4}-(0[1-9]|1[0-2])$/;
exports.AdminWithdrawalQuerySchema = zod_1.z.object({
    status: withdrawals_1.WithdrawalStatusSchema.optional(),
    chainCode: zod_1.z.string().min(1).optional(),
    userId: zod_1.z.uuid().optional(),
    period: zod_1.z.string().regex(PERIOD).optional(),
    cursor: zod_1.z.string().optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(100).catch(100).default(20),
});
exports.AdminWithdrawalSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    status: withdrawals_1.WithdrawalStatusSchema,
    userId: zod_1.z.uuid(),
    userEmail: zod_1.z.string(),
    userUsername: zod_1.z.string().nullable(),
    /** BigInt in the database; a string on the wire so no precision is lost in JSON. */
    userTelegramId: zod_1.z.string(),
    chainCode: zod_1.z.string(),
    chainName: zod_1.z.string(),
    symbol: zod_1.z.string(),
    decimals: zod_1.z.number().int().min(0),
    amount: wallet_1.AtomicAmountSchema,
    toAddress: zod_1.z.string(),
    txHash: zod_1.z.string().nullable(),
    explorerUrl: zod_1.z.url().nullable(),
    approvalRequired: zod_1.z.boolean(),
    approvedByName: zod_1.z.string().nullable(),
    rejectedReason: zod_1.z.string().nullable(),
    errorCode: zod_1.z.string().nullable(),
    /** Fluxson's own message. Ops-facing, never shown to the user. */
    errorMessage: zod_1.z.string().nullable(),
    fluxsonWithdrawalId: zod_1.z.uuid().nullable(),
    createdAt: zod_1.z.iso.datetime(),
    completedAt: zod_1.z.iso.datetime().nullable(),
});
exports.AdminWithdrawalListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.AdminWithdrawalSchema),
    nextCursor: zod_1.z.string().nullable(),
    /** How many rows are waiting for a human right now, regardless of the current filter. */
    reviewCount: zod_1.z.number().int().min(0),
});
exports.RejectWithdrawalRequestSchema = zod_1.z.object({ reason: zod_1.z.string().trim().min(1).max(500) });
exports.UserQuotaSchema = zod_1.z.object({
    chainCode: zod_1.z.string(),
    chainName: zod_1.z.string(),
    period: zod_1.z.string().regex(PERIOD),
    used: zod_1.z.number().int().min(0),
    /** The configured monthly limit, before the bonus. */
    configured: zod_1.z.number().int().min(0),
    bonus: zod_1.z.number().int().min(0),
    resetsAt: zod_1.z.iso.datetime(),
});
exports.UpdateQuotaRequestSchema = zod_1.z
    .object({ used: zod_1.z.number().int().min(0).max(1000).optional(), bonus: zod_1.z.number().int().min(0).max(1000).optional() })
    .refine((value) => value.used !== undefined || value.bonus !== undefined, { message: 'nothing to update' });
exports.UserAssetFlagSchema = zod_1.z.object({
    assetCode: zod_1.z.string(),
    symbol: zod_1.z.string(),
    chainName: zod_1.z.string(),
    withdrawEnabled: zod_1.z.boolean(),
    /** True when staff set this user by hand; the asset-level fan-out then skips them. */
    overridden: zod_1.z.boolean(),
    syncError: zod_1.z.string().nullable(),
});
exports.AssetSyncStateSchema = zod_1.z.object({
    assetCode: zod_1.z.string(),
    withdrawEnabled: zod_1.z.boolean(),
    total: zod_1.z.number().int().min(0),
    synced: zod_1.z.number().int().min(0),
    failed: zod_1.z.number().int().min(0),
});
//# sourceMappingURL=withdrawals.js.map